import React from 'react';
import { Instagram, Mail, FileText } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import Seo from '@/components/Seo';
import Reveal from '@/components/Reveal';
import PageHero from '@/components/PageHero';

const Contact = () => {
  return (
    <div className="relative z-10 min-h-screen">
      <Seo title="Contact" description="Contact Forever Path Living™ by email or Instagram, or begin a conversation through our interest and referral forms. We welcome families, guardians, and referral professionals." />
      <PageHero
        eyebrow="We'd Love to Hear From You"
        title="Contact Us"
        subtitle="We welcome inquiries from families, guardians, support coordinators, and referral partners."
      />

      <section className="py-20 md:py-28 px-6 bg-cream-100">
        <div className="max-w-4xl mx-auto">
          <Reveal>
            <Card className="p-8 md:p-12 bg-cream-200 border border-sage-200 rounded-3xl shadow-[0_8px_30px_rgba(59,77,65,0.06)] mb-8">
              <div className="grid sm:grid-cols-2 gap-8">
                <div className="flex items-start gap-4">
                  <div className="p-4 rounded-2xl bg-sage-100 text-forest-700 flex-shrink-0"><Mail className="w-6 h-6" /></div>
                  <div>
                    <h3 className="font-serif text-xl text-forest-800 mb-2">Email Us</h3>
                    <a href="mailto:admin@foreverpathliving.com" data-testid="contact-email-link" className="text-forest-700 hover:text-gold-700 transition-colors break-all">
                      admin@foreverpathliving.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="p-4 rounded-2xl bg-sage-100 text-forest-700 flex-shrink-0"><Instagram className="w-6 h-6" /></div>
                  <div>
                    <h3 className="font-serif text-xl text-forest-800 mb-2">Instagram</h3>
                    <a href="https://instagram.com/foreverpathliving" target="_blank" rel="noopener noreferrer" data-testid="contact-instagram-link" className="text-forest-700 hover:text-gold-700 transition-colors">
                      @foreverpathliving
                    </a>
                  </div>
                </div>
              </div>
            </Card>
          </Reveal>

          <Reveal delay={80}>
            <Card className="p-8 md:p-10 bg-forest-900 text-sage-100 rounded-3xl border border-forest-800">
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-2xl bg-forest-800 text-gold-500 flex-shrink-0"><FileText className="w-6 h-6" /></div>
                <div className="min-w-0">
                  <h3 className="font-serif text-xl text-cream-100 mb-3">Begin a Conversation</h3>
                  <p className="text-sage-100/85 leading-relaxed mb-5">
                    The best way to reach us is through our interest and referral forms. Whether you are a family
                    member or a referral professional, we would be honored to begin building a relationship with you.
                  </p>
                  <Link to="/placement" className="inline-block w-full sm:w-auto">
                    <Button data-testid="contact-forms-btn" className="w-full sm:w-auto whitespace-normal rounded-full bg-cream-100 hover:bg-white text-forest-900 px-6 sm:px-8 py-6 text-base font-semibold">
                      Go to Interest & Referral Forms
                    </Button>
                  </Link>
                </div>
              </div>
            </Card>
          </Reveal>
        </div>
      </section>

      <section className="py-16 md:py-20 px-6 bg-sage-100">
        <Reveal className="max-w-4xl mx-auto text-center">
          <p className="font-serif text-2xl md:text-3xl text-forest-800 italic">
            Because Every Story Deserves a Forever Path™
          </p>
        </Reveal>
      </section>
    </div>
  );
};

export default Contact;
